import {
  GET_FORM_REQUEST,
  SUBMIT_RESPONSE_REQUEST,
  CONTACT_FORM_REQUEST,
  CONTACT_US_FORM_REQUEST,
  SUBSCRIBE_FORM_REQUEST,
  FEEDBACK_FORM_REQUEST
} from './constants';

export const getForm = (code) => ({ type: GET_FORM_REQUEST, code });

export const submitResponse = (
  response,
  formId,
  successFunction,
  failFunction
) => ({
  type: SUBMIT_RESPONSE_REQUEST,
  response,
  formId,
  successFunction,
  failFunction
});

export const contactUs = (form, successFunction) => ({
  type: CONTACT_US_FORM_REQUEST,
  form,
  successFunction
});

export const subscribe = (form, successFunction, failFunction) => ({
  type: SUBSCRIBE_FORM_REQUEST,
  form,
  successFunction,
  failFunction
});

export const feedback = (form, successFunction, failFunction) => ({
  type: FEEDBACK_FORM_REQUEST,
  form,
  successFunction,
  failFunction
});

export const contact = (form, successFunction, failFunction) => ({
  type: CONTACT_FORM_REQUEST,
  form,
  successFunction,
  failFunction
});
